/** author: 胡枭 */
<template>
  <jczh-upload
    ref="upload"
    v-bind="propsValue"
    :file-id-before.sync="fileIdBeforeTemp"
    :group-id-before.sync="groupIdBeforeTemp"
    @change="fileList => $emit('change', fileList)"
  >
    <template v-slot:btn="{ progress }">
      <slot name="btn" :progress="progress"></slot>
    </template>
    <slot slot="tip" name="tip">
      <div v-if="!propsData.photoWall" class="important-tip m-l-10">
        支持pdf/doc/docx/xls/xlsx/ppt/pptx类型文件上传，word类型文件单个最大50MB；其他类型文件单个最大200MB；最多上传10个。
      </div>
    </slot>
  </jczh-upload>
</template>

<script>
import {
  // fileId和groupId使用的获取上传凭证接口
  signatureApi,
  // resource使用的获取上传凭证的接口
  getUploadPolicy,
  // 文件上传接口
  uploadFileApi,
  getGroupApi,
  getFileListByGroupIdApi,
  getFileListByFileIdsApi,
  getFileUrlByFileIdApi,
  getFilePreviewUrlApi,
  deleteFileApi,
  setWatermarkApi
} from '@/api/up-file.js'

// 引入vuex的工具函数
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'Upload',

  props: {
    propsData: {
      type: Object,
      default: () => {}
    },

    fileIdBefore: {
      type: [String, Number, Array],
      default: ''
    },

    groupIdBefore: {
      type: [String, Number, Array],
      default: ''
    }
  },

  computed: {
    ...mapState('user', ['employeeId']),
    ...mapGetters('company', ['platformTitle']),

    fileIdBeforeTemp: {
      get() {
        return this.fileIdBefore || this.propsData.fileIdBefore
      },
      set(val) {
        this.$emit('update:fileIdBefore', val)
      }
    },

    groupIdBeforeTemp: {
      get() {
        return this.groupIdBefore || this.propsData.groupIdBefore
      },
      set(val) {
        this.$emit('update:groupIdBefore', val)
      }
    },

    // 传入jczh-ui的参数
    propsValue() {
      return Object.assign(
        {},
        {
          platform: process.env.VUE_APP_PLATFORM_CONSTANT,
          watermarkText: this.platformTitle,
          ossDomain: process.env.VUE_APP_OSS_API,
          employeeId: this.employeeId,
          signatureApi: this.signatureApiTemp,
          uploadFileApi: uploadFileApi,
          deleteFileApi: deleteFileApi,
          getGroupIdApi: this.getGroupId,
          getFileListByGroupIdApi: getFileListByGroupIdApi,
          getFileUrlByFileIdApi: getFileUrlByFileIdApi,
          getFileInfoByFileIdApi: getFileListByFileIdsApi,
          getFileWPSPreviewMesApi: getFilePreviewUrlApi,
          setWatermarkApi: setWatermarkApi
        },
        this.propsData
      )
    }
  },

  methods: {
    // 根据传入的uploadMode确定使用的获取凭证函数
    signatureApiTemp(platform, params) {
      if (this.propsData.uploadMode === 'resource') {
        return new Promise((resolve, reject) => {
          getUploadPolicy(params)
            .then(res => {
              resolve(res)
            })
            .catch(err => {
              this.$message.error(err.message)
              reject()
            })
        })
      } else {
        return new Promise((resolve, reject) => {
          signatureApi(platform, params)
            .then(res => {
              resolve(res)
            })
            .catch(err => {
              this.$message.error(err.message)
              reject()
            })
        })
      }
    },
    getGroupId(data) {
      return new Promise((resolve, reject) => {
        getGroupApi(data)
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            this.$message.error(err.message)
            reject()
          })
      })
    },
    uploadComplete() {
      return this.$refs.upload.uploadComplete()
    },
    getFileList() {
      if (this.$refs.upload) return this.$refs.upload.fileList || []
      return []
    }
  }
}
</script>
